import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PageWrapper = ({ children }) => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <div className="page-fade-in" key={location.pathname}>
      {children}
    </div>
  );
};

export default PageWrapper;
